import { render, staticRenderFns } from "./tabel_2.vue?vue&type=template&id=1cb0d289&"
import script from "./tabel_2.vue?vue&type=script&lang=js&"
export * from "./tabel_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports